var pad = require('./pad');

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/lpad.js
// module id = 447
// module chunks = 0